import React from "react";
import { Typography } from "@mui/material";

export type SidebarSectionLabelProps = {
  children: string;
};

export function SidebarSectionLabel({ children }: SidebarSectionLabelProps) {
  return (
    <Typography
      variant="caption"
      sx={{
        color: "#9E9E9E",
        fontSize: 10,
        letterSpacing: 0.5,
        marginTop: "16px",
        marginBottom: "8px",
      }}
    >
      {children}
    </Typography>
  );
}
